import VueRouter, { RouteConfig } from 'vue-router'

const EastChinaNormalUniversityPage = () => import('../views/east-china-normal-university/LandingPage.vue')
const LandingPageNewSemesterPage = () => import('../views/east-china-normal-university/LandingPageNewSemester.vue')

const EastChinaNormalUniversitySelectClassPage = () =>
  import('../views/east-china-normal-university/SelectClassPage.vue')
const EastChinaNormalUniversitySharePosterPage = () => import('../views/east-china-normal-university/SharePoster.vue')
const EastChinaNormalUniversityActivityRulePage = () =>
  import('../views/east-china-normal-university/ActivityRulePage.vue')

// const
export const eastChinaNormalUniversityRoute: RouteConfig = {
  path: '/east-china-normal-university-landing',
  name: 'east_china_normal_university_landing',
  component: EastChinaNormalUniversityPage,
}

export const landingPageNewSemesterPageRoute: RouteConfig = {
  path: '/ecnu-new-semester-landing',
  name: 'ecnu_new_semester_landing',
  component: LandingPageNewSemesterPage,
  meta: {
    title: '新学期体育家庭作业',
  },
}

export const eastChinaNormalUniversitySelectClassRoute: RouteConfig = {
  path: '/east-china-normal-university-select-class',
  name: 'east_china_normal_university_select_class',
  component: EastChinaNormalUniversitySelectClassPage,
  props: (route) => ({
    from: route.query.from,
  }),
}

export const eastChinaNormalUniversitySharePosterRoute: RouteConfig = {
  path: '/east-china-normal-university-poster',
  name: 'east_china_normal_university_poster',
  component: EastChinaNormalUniversitySharePosterPage,
  props: (route) => ({
    from: route.query.from,
  }),
}

export const eastChinaNormalUniversityActivityRuleRoute: RouteConfig = {
  path: '/east-china-normal-university-activity-rule',
  name: 'east_china_normal_university_activity_rule',
  component: EastChinaNormalUniversityActivityRulePage,
}

const REastChinaNormalUniversityRoute: RouteConfig[] = [
  eastChinaNormalUniversityRoute,
  landingPageNewSemesterPageRoute,
  eastChinaNormalUniversitySelectClassRoute,
  eastChinaNormalUniversitySharePosterRoute,
  eastChinaNormalUniversityActivityRuleRoute,
]

export default REastChinaNormalUniversityRoute

export function navigateToESNULanding(router: VueRouter) {
  router.push({ name: eastChinaNormalUniversityRoute.name })
}

export function navigateToESNUSelectClass(router: VueRouter) {
  router.push({ name: eastChinaNormalUniversitySelectClassRoute.name })
}

export function navigateToESNUSharePoster(router: VueRouter) {
  router.push({ name: eastChinaNormalUniversitySharePosterRoute.name })
}

export function navigateToESNUActivityRulePage(router: VueRouter) {
  router.push({ name: eastChinaNormalUniversityActivityRuleRoute.name })
}
